import { Footer } from './components/footer';
import { Header } from './components/header';
import { SmoothScrollHero } from './components/smooth-scroll-hero';
import { motion, useScroll, useTransform } from 'framer-motion';
import { calculatePastYears } from './utils/calculate-past-years';

function App() {
  const { scrollY } = useScroll();

  const leftX = useTransform(scrollY, [0, 500], [0, -500]);
  const rightX = useTransform(scrollY, [0, 500], [0, 500]);
  const opacity = useTransform(scrollY, [0, 500], [1, 0]);

  return (
    <div className="relativ">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 flex flex-col items-center gap-8 overflow-x-hidden sm:overflow-x-visible">
        <h1 className="text-7xl font-extrabold text-white drop-shadow-lg ">
          Schmeckt lecker
        </h1>

        <div className="flex flex-col gap-4 text-white/90">
          <motion.p
            className="text-3xl font-medium drop-shadow-lg "
            style={{ x: leftX, opacity }}
          >
            Türkische Spezialitäten
          </motion.p>

          <motion.p
            className="max-w-xl text-left text-xl drop-shadow-lg "
            style={{ x: rightX, opacity }}
          >
            Hochwertige Speisen täglich frisch zubereitet. Ohne Zusatzstoffe,
            Konservierungsmittel oder Geschmacksverstärker. Seit{' '}
            {calculatePastYears()} Jahren in Meschede. Aus Tradition gut.
          </motion.p>
        </div>
      </div>
      <Header />
      <SmoothScrollHero />
      <Footer />
    </div>
  );
}

export default App;
